import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {sendEvarData} from '@ibibo/analytics';
import {
  tokenSelector,
  errorSelector,
  docTypeListSelector,
  statusSelector,
  nextLoader,
  additionalDocSelector,
  kycDocumentSelector,
  nextScreenSelector,
  kycUploadedSelector,
  facadeUploadedSelector,
} from '../../../store/selectors';
import * as actions from '../../../store/actions/index';
import useRedirect from '../hooks/useRedirection';
import {
  UPDATE_PAGE_URL,
  NON_EDITABLE_STATUS,
  VERIFY_PAGE_URL,
  CREATE_PASSWORD_PAGE_URL,
  LOGIN_WITH_MMT_PASSWORD_URL,
} from '../../../constants';
import SupportingDocument from '../../../stories/components/OnboardingNew/PopUp/SupportingDocument/SupportingDocument';
import {getCrid} from '../../../../../myaccount/src/utils/redirectWithCrId';

const DocUpload = () => {
  const [disableSubmitButton, setDisableSubmitButton] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();

  const data = useSelector(kycDocumentSelector);
  const token = useSelector(tokenSelector);
  const error = useSelector(errorSelector);
  const status = useSelector(statusSelector);
  const setLoader = useSelector(nextLoader);
  const kycUplaoded = useSelector(kycUploadedSelector);
  const facadeUploaded = useSelector(facadeUploadedSelector);

  const nextScreen = useSelector(nextScreenSelector);
  const docTypeList = useSelector(docTypeListSelector);
  // const docTypeList = {
  //   "eb": "Electricity Bill",
  //   "bs": "Bank Statement"
  // }

  const additionalDocType = useSelector(additionalDocSelector);
  // const additionalDocType = {
  //   "ua": "Udhyog Aadhar",
  //   "cc": "Crossed Cheque",
  //   "gstnc": "GSTN Certificate"
  // };

  useEffect(() => {
    if (facadeUploaded || kycUplaoded) {
      setDisableSubmitButton(false);
    }
  }, [facadeUploaded, kycUplaoded]);

  const uploadKYC = ({kycFile, kycDocType}) => {
    sendEvarData(
      {
        prop54: `myPartner|signup|businessVerification|documentUpload|${kycDocType}`,
      },
      true,
    );
    let fd = new FormData();
    fd.append('token', token);
    fd.append('document_type', kycDocType);
    fd.append('file', kycFile, 'kycImage.png');
    dispatch(actions.submitKYC(fd, kycDocType));
  };

  const uploadFacade = ({facadeFile}) => {
    sendEvarData(
      {
        prop54: 'myPartner|signup|businessVerification|documentUpload|facade',
      },
      true,
    );
    let fd = new FormData();
    fd.append('token', token);
    fd.append('document_type', 'fd');
    fd.append('file', facadeFile, 'fdImage.png');
    dispatch(actions.submitFacade(fd, 'fd'));
  };

  const successCallback = screen => {
    setDisableSubmitButton(false);
    if (screen === 'create_password') {
      history.push(`${CREATE_PASSWORD_PAGE_URL}?crId=${getCrid()}`);
    } else if (screen === 'mmt_password') {
      history.push(`${LOGIN_WITH_MMT_PASSWORD_URL}?crId=${getCrid()}`);
    }
  };

  const errorCallBack = () => {
    setDisableSubmitButton(false);
  };

  const submitInfo = dataObj => {
    // if (NON_EDITABLE_STATUS.indexOf(status) !== -1) {
    //   successCallback();
    //   return;
    // }
    setDisableSubmitButton(true);
    const dataToSubmit = {
      token: token,
    };
    let fd = new FormData();
    for (var key in dataToSubmit) {
      fd.append(key, dataToSubmit[key]);
    }

    dispatch(actions.submitKycDoc(fd, dataToSubmit, successCallback, errorCallBack));
  };

  return (
    <SupportingDocument
      data={data}
      error={error}
      status={status}
      submitDetails={data => submitInfo(data)}
      uploadKYC={data => uploadKYC(data)}
      uploadFacade={data => uploadFacade(data)}
      kycDocList={docTypeList}
      setLoader={setLoader}
      addDocList={additionalDocType}
      disableSubmitButton={disableSubmitButton}
    />
  );
};

export default DocUpload;
